<template>
  <div
    id="file-table"
    class="file-table table mx-5 mb-5 h-100">
    <!-- File Table Head -->
    <div class="thead">
      <div class="tr">
        <div class="th file-filename">
          Filename
        </div>
        <div class="th file-relative-url">
          Relative URL
        </div>
        <div class="th file-uploaded-on">
          Uploaded On
        </div>
        <div class="th file-delete">
        </div>
      </div>
    </div>
    <!-- / File Table Head -->

    <!-- File Table Body -->
    <div class="tbody">
      <div
        class="tr"
        v-for="file in files"
        :key="file.fileName">
        <div class="th file-filename">
          {{file.fileName}}
        </div>
        <div class="th file-relative-url d-flex align-center">
          {{file.relativeUrl}}
          <v-btn
            @click="copyUrl(file.relativeUrl)"
            :loading="copyLoading"
            :disabled="copyLoading"
            class="ml-2 px-1 py-1"
            color="primary"
            type="button"
            x-small
            depressed
            outlined>
            Copy URL
          </v-btn>
        </div>
        <div class="th file-uploaded-on">
          {{file.lastWriteTimeString}}
        </div>
        <div class="th file-delete">
          <v-btn
            @click="deleteFile(file.fileName)"
            color="secondary"
            type="button"
            depressed
            block>
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- No Files Warning -->
      <div
        class="tr"
        v-if="files.length === 0">
        <div class="td mx-auto">
          There are no files to show.
        </div>
      </div>
      <!-- / No Files Warning -->
    </div>
    <!-- / File Table Body -->
  </div>
</template>

<script>
export default {
  name: 'FileList',
  props: ['files'],
  data() {
    return {
      copyLoading: false,
    };
  },
  methods: {
    deleteFile(fileName) {
      this.showConfirm(
        `Are you sure you want to delete <b>${fileName}</b>?`,
        'Delete File',
      ).then(() => this.$store.dispatch('deleteFile', { fileName }), () => {});
    },
    copyUrl(str) {
      this.copyLoading = true;
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      setTimeout(() => {
        this.copyLoading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss">
#file-table {
  height: calc(100% - 100px);
}
</style>
